if (!customElements.get('daluca-gallery-colors')) {
  customElements.define('daluca-gallery-colors', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.thb-product-detail');
      if (!this.scope) return;
      this.list = this.querySelector('.daluca-gallery-colors__list');
      this.toggle = this.querySelector('[data-colors-toggle]');
      this.label = this.querySelector('[data-selected-color]');
      this.sync = this.sync.bind(this);
      this.onChoice = this.onChoice.bind(this);
      this.queueSync = this.queueSync.bind(this);
      this.addEventListener('click', this.onChoice);
      this.scope.addEventListener('change', this.sync);
      document.addEventListener('product:variant-change', this.sync);
      this.mobile = window.matchMedia('(max-width: 600px)');
      this.mobile.addEventListener('change', this.sync);
      this.resizeObserver = new ResizeObserver(entries => {
        const width = Math.round(entries[0].contentRect.width);
        if (width !== this.lastWidth) { this.lastWidth = width; this.queueSync(); }
      });
      this.resizeObserver.observe(this.list);
      this.observer = new MutationObserver(records => {
        const selector = 'variant-selects,.gpo-element,.gpo-app,input[type="radio"],select';
        if (records.some(record => !this.contains(record.target) &&
          [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 &&
            (node.matches(selector) || node.querySelector(selector))))) this.queueSync();
      });
      this.observer.observe(this.scope, { childList: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onChoice);
      this.scope?.removeEventListener('change', this.sync);
      document.removeEventListener('product:variant-change', this.sync);
      this.mobile?.removeEventListener('change', this.sync);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    queueSync() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.sync);
    }
    get picker() {
      if (this.dataset.nativeOption) {
        const selectors = Array.from(this.scope.querySelectorAll('variant-selects:not(.variant-selects--sticky)'));
        const selector = selectors.find(node => node.dataset.updateUrl === 'true') || selectors[0];
        return Array.from(selector?.querySelectorAll('fieldset') || [])
          .find(field => field.dataset.handle === this.dataset.nativeOption);
      }
      return Array.from(this.scope.querySelectorAll('.gpo-element')).find(field => {
        const name = window.DaLucaI18n.chainText(() => (field), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.gpo-label .label-content']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || '';
        return /^(?:(?:leather|strap|nylon|shell cordovan|lizard|alligator)\s+)?colou?r$/i.test(name) &&
          !field.hidden && getComputedStyle(field).display !== 'none' &&
          field.querySelectorAll('input[type="radio"]').length > 1;
      });
    }
    controls(picker) {
      const select = picker?.querySelector('select');
      return select ? Array.from(select.options).filter(option => option.value) :
        Array.from(picker?.querySelectorAll('input[type="radio"]') || []);
    }
    buildAppChoices(picker, controls) {
      const choices = controls.map(input => {
        const swatch = input.closest('.gpo-swatches');
        const image = swatch?.querySelector('.swatch-image');
        const price = window.DaLucaI18n.chainText(() => (swatch), [{kind:"member", optional:true, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.addOn']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || '';
        return { value: input.value, image: image?.getAttribute('src') || '', price };
      });
      const signature = JSON.stringify(choices);
      if (signature === this.signature) return;
      this.signature = signature;
      const fragment = document.createDocumentFragment();
      choices.forEach(choice => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'daluca-gallery-colors__choice';
        button.dataset.color = choice.value;
        button.dataset.colorTitleSource = [choice.value, choice.price].filter(Boolean).join(' ');
        button.title = [window.DaLucaI18n.displayText(choice.value), choice.price].filter(Boolean).join(' ');
        button.setAttribute('aria-label', button.title);
        const frame = document.createElement('span');
        frame.className = 'daluca-gallery-colors__image';
        if (choice.image) {
          const image = document.createElement('img');
          image.src = choice.image;
          image.alt = '';
          image.width = 48;
          image.height = 44;
          image.loading = 'lazy';
          frame.appendChild(image);
        } else {
          frame.classList.add('daluca-gallery-colors__image--text');
          window.DaLucaI18n.setText(frame, choice.value.replace(/\[.*?\]/g, '').trim());
        }
        const name = document.createElement('span');
        name.dataset.colorLabel = '';
        window.DaLucaI18n.setText(name, choice.value.replace(/\s*\[Limited Edition\]/i, ''));
        button.append(frame, name);
        if (choice.price) {
          const price = document.createElement('span');
          price.className = 'daluca-gallery-colors__price';
          window.DaLucaI18n.setText(price, choice.price.replace(/[()]/g, '').replace(/^\+\s*/, '+'));
          button.appendChild(price);
        }
        fragment.appendChild(button);
      });
      this.list.replaceChildren(fragment);
    }
    selectAppImage(selected, force = false) {
      if (this.dataset.nativeOption || !selected ||
        !this.scope.classList.contains('daluca-pdp--apple-standard') ||
        (!force && selected === this.galleryColor)) return;
      const slider = this.scope.querySelector('product-slider');
      if (!slider?.flkty || typeof slider.selectCell !== 'function') return;
      const color = selected.toLowerCase().replace(/[^a-z0-9]/g, '');
      const slide = Array.from(slider.querySelectorAll('.product-images__slide.is-active')).find(node => {
        const source = node.querySelector('.product-single__media-image img')?.getAttribute('src') || '';
        const filename = source.split('?')[0].split('/').pop().toLowerCase().replace(/[^a-z0-9]/g, '');
        return filename.includes(color) && filename.includes('thick') === color.includes('thick');
      });
      if (!slide?.id) return;
      slider.selectCell('#' + CSS.escape(slide.id));
      this.galleryColor = selected;
    }
    sync() {
      const picker = this.picker;
      const controls = this.controls(picker);
      if (controls.length < 2) { this.hidden = true; return; }
      if (!this.dataset.nativeOption) this.buildAppChoices(picker, controls);
      const buttons = Array.from(this.list.querySelectorAll('[data-color]'));
      if (buttons.length < 2) { this.hidden = true; return; }
      const selected = controls.find(input => input.checked || input.selected)?.value;
      this.selectAppImage(selected);
      const longLabels = buttons.some(button => window.DaLucaI18n.chainText(() => (button), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['[data-color-label]']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("length")}]) > 12);
      this.classList.toggle('daluca-gallery-colors--long', longLabels);
      this.hidden = false;
      const tileWidth = longLabels ? (this.mobile.matches ? 68 : 80) : 48;
      const limit = Math.max(1, Math.min(5, Math.floor((this.list.clientWidth + 8) / (tileWidth + 8)) || 5));
      const visibleButtons = buttons.slice(0, limit);
      const selectedButton = buttons.find(button => button.dataset.color === selected);
      if (selectedButton && !visibleButtons.includes(selectedButton)) visibleButtons[limit - 1] = selectedButton;
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      buttons.forEach((button, index) => {
        const input = controls.find(input => input.value === button.dataset.color);
        const pressed = button.dataset.color === selected;
        button.setAttribute('aria-pressed', String(pressed));
        button.disabled = !input || input.disabled;
        button.hidden = !expanded && !visibleButtons.includes(button);
      });
      const chosenButton = buttons.find(button => button.dataset.color === selected);
      const name = chosenButton?.dataset.colorTitleSource || chosenButton?.title || this.dataset.chooseColor;
      const displayName = chosenButton?.title || window.DaLucaI18n.displayText(name);
      window.DaLucaI18n.setDisplayText(this.label, name, displayName);
      this.toggle.hidden = buttons.length <= limit;
      const toggleText = expanded ? this.dataset.showLess : this.dataset.showAll;
      if (window.DaLucaI18n.sourceText(this.toggle) !== toggleText) window.DaLucaI18n.setText(this.toggle, toggleText);
      this.hidden = false;
    }
    onChoice(event) {
      if (event.target.closest('[data-colors-toggle]') === this.toggle) {
        this.toggle.setAttribute('aria-expanded', String(this.toggle.getAttribute('aria-expanded') !== 'true'));
        this.sync();
        return;
      }
      const button = event.target.closest('[data-color]');
      if (!button || !this.contains(button)) return;
      const picker = this.picker;
      const input = this.controls(picker).find(input => input.value === button.dataset.color);
      if (!input || input.disabled) return;
      if (input.tagName === 'OPTION') {
        const select = input.closest('select');
        if (!input.selected) { select.value = input.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
      } else if (!input.checked) input.click();
      this.sync();
      this.selectAppImage(button.dataset.color, true);
      this.queueSync();
    }
  });
}

